<template>
  <div
    class="tm-auto-size-panel-item"
    :class="{
      'tm-auto-size-panel-item--after-more': isAfterMore,
    }"
    :[autoSizeHidingPriorityAttributeName]="hidingPriority"
  >
    <slot :name="inDropdown && $slots['dropdown-item'] ? 'dropdown-item' : 'default'" />
  </div>
</template>

<script lang="ts" setup>
/**
 * The component is used in TmAutoSizePanel to wrap items and manage their hiding priority.
 * It also provides a slot for items in the more dropdown.
 *
 * Example:
 * <tm-auto-size-panel-item>
 *   <tm-button>Button 1</tm-button>
 *   <template v-slot:dropdown-item>
 *     <tm-dropdown-item label="Button 1" />
 *   </template>
 * </tm-auto-size-panel-item>
 */

import { ref, onMounted } from '@/composition/vue/compositionApi'
import { useInsideDropdown } from '@/composition/dropdown'
import {
  type AutoSizeHidingPriority,
  type AutoSizeHidingPriorityAttributeValue,
  autoSizeHidingPriorityAttributeName,
} from '@/composition/autoSize'

defineProps<{
  // Items with high priority are hidden first. Negative values are allowed.
  hidingPriority?: AutoSizeHidingPriority | AutoSizeHidingPriorityAttributeValue
  isAfterMore?: boolean
}>()

const inDropdown = ref(false)

onMounted(() => {
  inDropdown.value = !!useInsideDropdown().inject()
})
</script>

<style scoped lang="scss">
.tm-auto-size-panel-item {
  padding-left: calc(var(--tm-auto-size-panel-gap) / 2);
  padding-right: calc(var(--tm-auto-size-panel-gap) / 2);

  &--after-more {
    order: 2;
  }
}
</style>
